export const AUTH0_FLEX_APP_STATE_KEY = 'auth0_flex_app_state';

/** Called from Auth0Provider onRedirectCallback so Flex bridge can read return path after OAuth round-trip. */
export const persistAuth0AppState = appState => {
  if (typeof window === 'undefined' || !appState) {
    return;
  }
  try {
    sessionStorage.setItem(AUTH0_FLEX_APP_STATE_KEY, JSON.stringify(appState));
  } catch (e) {
    // ignore quota / private mode
  }
};

/** Returns parsed app state and removes it from sessionStorage (one-shot). */
export const consumeAuth0AppState = () => {
  try {
    const raw = sessionStorage.getItem(AUTH0_FLEX_APP_STATE_KEY);
    if (!raw) {
      return {};
    }
    sessionStorage.removeItem(AUTH0_FLEX_APP_STATE_KEY);
    return JSON.parse(raw);
  } catch (e) {
    return {};
  }
};
